import { Dispatch, SetStateAction, useEffect, useRef } from "react";

import { useRedirectStore } from "@/stores/useRedirectStore";

import { CompanyCardDto } from "../../../types";

interface UseCompanyCardFunctionsProps {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  setHasHighlight: Dispatch<SetStateAction<boolean>>;
  cardData: CompanyCardDto | undefined;
}

export const useCompanyCardFunctions = ({
  isOpen,
  setIsOpen,
  setHasHighlight,
  cardData
}: UseCompanyCardFunctionsProps) => {
  const { takeToCompaniesCards, setTakeToCompaniesCards } = useRedirectStore();

  const takeToCompaniesCardsTriggered = useRef<boolean>(false);

  // Trigger collapse card by id on "take me there" from ccExpiry click in dashboard
  useEffect(() => {
    if (takeToCompaniesCards && takeToCompaniesCards === cardData?.id) {
      handleToggleCollapse();
      setHasHighlight(true);

      // Remove highlight
      setTimeout(() => {
        setHasHighlight(false);
      }, 2700);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cardData, takeToCompaniesCards]);

  const handleToggleCollapse = () => {
    const isFromTakeToCompaniesCards = Boolean(takeToCompaniesCards);

    setIsOpen(isFromTakeToCompaniesCards || !isOpen);
    setTakeToCompaniesCards(null);
    takeToCompaniesCardsTriggered.current = true;
  };
  return { handleToggleCollapse };
};
